import 'normalize.css'
import '@revolut-internal/ui-kit/styles.css'

import { renderApp } from 'containers/Bootstrap'
import { setupSentry } from 'lib/sentry'
import { auth, permissions } from 'lib/auth'

export const init = () => {
  auth.init().then(user => {
    if (!user) {
      return
    }

    permissions.init({ rmail: user?.permissions }).then(() => {
      if (process.env.NODE_ENV === 'production') {
        setupSentry().withScope(() => {
          renderApp()
        })
      } else {
        renderApp()
      }
    })
  })
}
